var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disable-scrollbars"},[_c('NotificationsWrapper',{staticClass:"mr-4"}),_vm._v(" "),_c('div',{staticClass:"safe-left safe-right safe-bottom safe-top"},[_c('Nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }